export default __webpack_public_path__ + "static/media/SRHR_in_UHC_plans_and_processes_in_Eastern_Europe_and_Central_Asia.52539b24.png";